<template>
	<vs-prompt
		@accept="addManager"
		:active.sync="popupActive"
		:title="$t('selectMultiManagersTitle')"
		:acceptText="$t('save')"
		:cancelText="$t('cancel')"
		class="add-order-task"
	>
		<div>
			<vx-input-group class="mb-4">
                <div class="form-group form-check">
                    <div class="flex mb-4"
                        v-for="manager in listManagers"
                    >
                        <input class="mr-2 text-lg" :id="manager.id" type="checkbox" :value="manager.id" v-model="selectedManagers"> 
                        <label class="text-lg" :for="manager.id">
							<span class="frsSelectSpanManager text-lg">
								<img :src="manager.photo" />
								{{ manager.full_name }}&nbsp; 
								<span class="text-sm">
									<feather-icon icon="ClipboardIcon"></feather-icon>:&nbsp; 
									<strong>{{ manager.count_active_order }}</strong>
								</span>
							</span>
						</label>
                    </div>
                </div>
			</vx-input-group>
		</div>
	</vs-prompt>
</template>

<script>
import databaseManager from "@/mixins/databaseManager";
import notifier from "@/mixins/notifier";

export default {
	name: "ChangeManagerForDutySchedule",
	mixins: [databaseManager, notifier],
	props: {
		active: { required: true, type: Boolean },
		theDay: { required: true },
		theLine: { required: true },
	},
	data() {
		return {
            listManagers: [],
            selectedManagers: [],
            newM: [],
		}
	},
	watch: {
		popupActive(value) {
			if(value) {
                this.getDutyScheduleList();
                return;
            } 
		}
	},
	computed: {
		popupActive: {
			get() {
				return this.active;
			},
			set(newValue) {
				this.$emit("update:active", newValue);
			}
		},
	},
	methods: {
        async getDutyScheduleList() {
            this.selectedManagers = [];
            this.listManagers = await this.dbGetDutyScheduleList(this.theDay, this.theLine);
            // console.log(this.listManagers);
        },
		async addManager() {
			this.popupActive = false;
            this.$emit("confirm", this.selectedManagers);
            this.selectedManagers = [];
		},
	},
    created() {
        this.selectedManagers = [];
    },
};
</script>

<style lang="scss">
.frsSelectSpanManager {
	display: flex;
	line-height: 40px;
	font-size: small;
	color: black;
  
	img {
		width: 40px;
		margin-right: 10px;
	}	

}
.add-order-task {
	.append-text {
		height: 2.7rem;
	}

	.vs-button {
		border-left: 0;
	}

	.vx-input-group-append {
		align-items: flex-end;
	}

	.vs-input {
		width: 100%;

		textarea {
			resize: none;
		}
	}
}
</style>
